exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active-e-query-label {\n  margin: 10px 0;\n  font-weight: bold;\n}\n\n", ""]);

// exports
